module.exports = __webpack_public_path__ + "static/media/switch_off.2ebda0bb.png";